import Hourglass from 'lucide-react/dist/esm/icons/hourglass';
import Star from 'lucide-react/dist/esm/icons/star';
import Zap from 'lucide-react/dist/esm/icons/zap';
import React from 'react';

export type AnnouncementResponse = { message: string | null; category?: AnnouncementCategory };

export enum AnnouncementLevel {
	LOCAL = 'Local',
	GLOBAL = 'Global'
}

export enum AnnouncementCategory {
	URGENCY = 'Urgency',
	SCARCITY = 'Scarcity',
	POPULARITY = 'Popularity',
	CUSTOM = 'Custom',
}

export const getAnnouncementCategoryTitle = (category: AnnouncementCategory, t: (key: string) => string): string => {
	const titleMap: Record<AnnouncementCategory, string> = {
		[AnnouncementCategory.URGENCY]: t('announcements.booking_fast'),
		[AnnouncementCategory.SCARCITY]: t('announcements.last_chance'),
		[AnnouncementCategory.POPULARITY]: t('announcements.most_popular'),
		[AnnouncementCategory.CUSTOM]: ''
	};
	return titleMap[category];
};

const ICON_SIZE = 20;
const ICON_COLOR = '#E9A62A';

const iconProps = {
	size: ICON_SIZE,
	color: ICON_COLOR,
	fill: ICON_COLOR
};

export const AnnouncementCategoryLucideIconMap: Record<AnnouncementCategory, React.ReactNode> = {
	[AnnouncementCategory.URGENCY]: <Zap {...iconProps} />,
	[AnnouncementCategory.SCARCITY]: <Hourglass {...iconProps} />,
	[AnnouncementCategory.POPULARITY]: <Star {...iconProps} />,
	[AnnouncementCategory.CUSTOM]: ''
};
